/**
 * @author Abdelghani AINOUSS 
 * 
 */
// TODO share logic between directive & component
// TODO provide an injectable configuartion for the module

import { Injectable } from '@angular/core';



@Injectable()
export class NgAutonumericService {

    constructor(){

    }
}